import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import './index.css';
import App from './App';
import { fetchWithAuth } from './utils/fetchWithAuth';

const Index = () => {
    useEffect(() => {
        // Only fetch title if we have a valid cookie
        // This prevents unnecessary API calls on login page
        fetch('/api/title', { credentials: 'include' })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
            })
            .then(config => {
                if (config?.title) {
                    document.title = config.title;
                }
            })
            .catch(() => {
                document.title = 'AI Chat';
            });
    }, []);

    return (
        <React.StrictMode>
            <ChakraProvider theme={theme}>
                <App />
            </ChakraProvider>
        </React.StrictMode>
    );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Index />);

